module.exports = __webpack_public_path__ + "kudos_1.svg?f140c6840df8b06e24696eff09059d2a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_1.svg
// module id = 106
// module chunks = 0